import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import moment from "moment";
import { ArrowRightIcon, BusIcon, EditIcon } from "assets/icons";
import { Checkbox, Switch } from "components";
import {
  setBooking,
  setTicketActiveStep,
  setActiveSection,
  setOpenTicketDetail,
} from "../../redux/reducers/bookingReducer";

function Step2() {
  const dispatch = useDispatch();
  const { busDetail, booking } = useSelector((state) => state.bookingReducer);
  const boardingPassPrice = 1.5;
  const travelProtectionPrice = 1;

  const handleChange = (index, field, value) => {
    const updatedData = booking.passengerData.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    dispatch(setBooking({ ...booking, passengerData: updatedData }));
  };

  const handleProceed = () => {
    let allValid = true;

    booking?.passengerData.forEach((passenger, index) => {
      const passengerNumber = index + 1;
      if (!passenger?.name) {
        toast.error(`Passenger ${passengerNumber} name is required.`);
        allValid = false;
        return;
      }
      if (!passenger?.age) {
        toast.error(`Passenger ${passengerNumber} age is required.`);
        allValid = false;
        return;
      }
    });

    if (!allValid) {
      return;
    } else if (!booking.mobile) {
      toast.error(`Mobile number is required`);
      return;
    } else if (!booking.email) {
      toast.error(`Email is required`);
      return;
    }

    document.body.style.overflow = "auto";
    dispatch(setOpenTicketDetail(false));
    dispatch(setActiveSection("checkout"));
  };

  return (
    <div className="w-full flex flex-col">
      <div className="w-full px-5  md:px-8 py-6 sm:py-8">
        <div className="w-full flex flex-col gap-4">
          <div className="w-full flex items-center justify-between gap-2">
            <div className="text-sm sm:text-base font-medium text-black">
              {busDetail?.boarding_city}
            </div>
            <div className="flex items-center gap-5">
              <div className="flex-1 text-sm sm:text-base font-medium text-black">
                Johor Bahru
              </div>
              {/* <button className="h-4 smh-5 w-4 sm:w-5 text-primary-700">
                <EditIcon />
              </button> */}
            </div>
          </div>
          <div className="w-full flex items-center justify-between gap-2">
            <div className="text-sm sm:text-base font-medium text-black">
              {busDetail?.bus_picktime}
            </div>
            <span className="h-3 sm:h-4 w-4 sm:w-4">
              <ArrowRightIcon />
            </span>
            <div className="text-sm sm:text-base font-medium text-black min-w-[103px]">
              01:28 pm
            </div>
          </div>
          <div className="w-full flex items-center justify-between gap-2">
            <div className="flex flex-col gap-1">
              <div className="text-sm sm:text-base sm:leading-5 font-medium text-[#63767E]">
                Date of Journey
              </div>
              <div className="text-sm sm:text-base sm:leading-5 font-medium text-[#263238]">
                {moment(busDetail?.trip_date).format("DD-MM-YYYY")}
              </div>
            </div>
            {/* <div className="flex flex-col gap-1">
              <div className="text-sm sm:text-base sm:leading-5 font-medium text-[#63767E]">
                Date of Journey
              </div>
              <div className="text-sm sm:text-base sm:leading-5 font-medium text-[#263238]">
                02-04-2024
              </div>
            </div> */}
          </div>
        </div>
        <div className="w-full h-[0.5px] bg-[#C4C4C480] my-6 sm:my-8" />
        <div className="w-full flex items-center">
          <div className="flex-1 flex items-center gap-6">
            <div className="flex items-center flex-wrap gap-2">
              <div className="text-sm sm:text-base font-medium text-[#5A5D63]">
                Upper Seat :
              </div>
              {booking.passengerData.map((item) => {
                if (item.seat_type === "upper") {
                  return (
                    <div className="text-sm sm:text-base font-medium text-[#1D1D1D]">
                      {item.seat_no}
                      <span>,&nbsp;</span>
                    </div>
                  );
                }
              })}
            </div>
            <div className="flex items-center flex-wrap gap-2">
              <div className="text-sm sm:text-base font-medium text-[#5A5D63]">
                Lower Seat :
              </div>
              {booking.passengerData.map((item) => {
                if (item.seat_type === "lower") {
                  return (
                    <div className="text-sm sm:text-base font-medium text-[#1D1D1D]">
                      {item.seat_no}
                      <span>,&nbsp;</span>
                    </div>
                  );
                }
              })}
            </div>
          </div>
          <button
            onClick={() => dispatch(setTicketActiveStep(1))}
            className="h-4 smh-5 w-4 sm:w-5 text-primary-700"
          >
            <EditIcon />
          </button>
        </div>
        <div className="w-full h-[0.5px] bg-[#C4C4C480] my-6 sm:my-8" />
        {booking.passengerData.length > 0 &&
          booking.passengerData.map((item, index) => (
            <div key={index}>
              <div className="w-full flex flex-col">
                <div className="text-black font-semibold text-sm sm:text-base">
                  {`Passenger ${index + 1} - ${item.seat_no}`}
                </div>
                <div className="text-[#858585] font-medium text-sm sm:text-base mb-5 sm:mb-7">
                  You need to fill in the passenger details to proceed
                </div>
                <input
                  type="text"
                  placeholder="Enter Full Name"
                  value={item.name || ""}
                  onChange={(e) => handleChange(index, "name", e.target.value)}
                  className="w-full h-[40px] py-3 px-4 text-sm font-medium text-black bg-[#ECEAEA] rounded-[10px] mb-6"
                />
                <input
                  type="text"
                  placeholder="Enter Age"
                  value={item.age || ""}
                  onChange={(e) => handleChange(index, "age", e.target.value)}
                  className="w-full h-[40px] py-3 px-4 text-sm font-medium text-black bg-[#ECEAEA] rounded-[10px] mb-6"
                />
                <div className="w-full flex items-center gap-12">
                  <label
                    className="flex items-center gap-3"
                    onClick={() => handleChange(index, "gender", "Male")}
                  >
                    <div className="h-[18px] w-[18px] p-0.5 rounded-full border-[2px] border-primary-700 flex items-center justify-center">
                      <div
                        className={`h-full w-full rounded-full animation ${
                          item.gender === "Male"
                            ? "bg-primary-700"
                            : "bg-transparent"
                        }`}
                      />
                    </div>
                    <div className="text-sm text-[#112211] font-medium">
                      Male
                    </div>
                  </label>
                  <label
                    className="flex items-center gap-3"
                    onClick={() => handleChange(index, "gender", "Female")}
                  >
                    <div className="h-[18px] w-[18px] p-0.5 rounded-full border-[2px] border-primary-700 flex items-center justify-center">
                      <div
                        className={`h-full w-full rounded-full animation ${
                          item.gender === "Female"
                            ? "bg-primary-700"
                            : "bg-transparent"
                        }`}
                      />
                    </div>
                    <div className="text-sm text-[#112211] font-medium">
                      Female
                    </div>
                  </label>
                </div>
              </div>
              <div className="w-full h-[0.5px] bg-[#C4C4C480] my-6 sm:my-8" />
            </div>
          ))}

        <div className="w-full flex flex-col">
          <div className="text-black font-semibold text-sm sm:text-base">
            Contact Details
          </div>
          <div className="text-[#858585] font-medium text-sm sm:text-base mb-5 sm:mb-7">
            You need to fill in the passenger details to proceed
          </div>
          <input
            type="text"
            placeholder="Enter Contact"
            value={booking.mobile}
            onChange={(e) =>
              dispatch(setBooking({ ...booking, mobile: e.target.value }))
            }
            className="w-full h-[40px] py-3 px-4 text-sm font-medium text-black bg-[#ECEAEA] rounded-[10px] mb-6"
          />
          <input
            type="text"
            placeholder="Enter Email"
            value={booking.email}
            onChange={(e) =>
              dispatch(setBooking({ ...booking, email: e.target.value }))
            }
            className="w-full h-[40px] py-3 px-4 text-sm font-medium text-black bg-[#ECEAEA] rounded-[10px] mb-6"
          />
        </div>
        <div className="w-full h-[0.5px] bg-[#C4C4C480] my-6 sm:my-8" />
        <div className="w-full flex flex-col">
          <div className="text-sm sm:text-base font-semibold text-black mb-3">
            Boarding Pass
          </div>
          <div className="w-full flex items-center gap-4 mb-4">
            <img
              src="/images/pass.png"
              alt=""
              className="h-[60px] sm:h-[86px] w-[60px] sm:w-[86px]"
            />
            <div className="w-full flex flex-col">
              <div className="text-[12px] sm:text-sm font-semibold text-primary-700 mb-1.5 sm:mb-3">
                Bus Boarding Pass
              </div>
              <div className="text-[12px] sm:text-sm font-medium text-[#112211]">
                Includes boarding pass & facility charges. Collected on behalf
                of the terminal
              </div>
            </div>
          </div>
          <div className="w-full flex items-center justify-between gap-2">
            <div className="flex-1 text-[12px] sm:text-sm font-medium text-black">
              Opt in at per passenger charges of RM{boardingPassPrice}
            </div>
            <Switch
              checked={booking.boarding_pass_price}
              changeChecked={() => {
                if (booking.boarding_pass_price) {
                  dispatch(
                    setBooking({
                      ...booking,
                      boarding_pass_price: "",
                    })
                  );
                } else {
                  dispatch(
                    setBooking({
                      ...booking,
                      boarding_pass_price: boardingPassPrice,
                    })
                  );
                }
              }}
            />
          </div>
        </div>
        <div className="w-full h-[0.5px] bg-[#C4C4C480] my-8" />
        <div className="w-full flex flex-col bg-white shadow-block py-6 px-6 rounded-[16px] mb-12">
          <div className="text-sm font-semibold text-black text-center mb-7">
            Travel Protection Includes:
          </div>
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-8">
            <div className="w-full flex gap-3">
              <span className="text-primary-700">
                <BusIcon />
              </span>
              <div className="w-full flex flex-col">
                <div className="text-sm font-semibold text-primary-700 mb-3">
                  Up to 2,000 RM
                </div>
                <div className="text-[10px] font-medium text-[#112211]">
                  Medical expenses due to accident
                </div>
              </div>
            </div>
            <div className="w-full flex gap-3">
              <span className="text-primary-700">
                <BusIcon />
              </span>
              <div className="w-full flex flex-col">
                <div className="text-sm font-semibold text-primary-700 mb-3">
                  Up to 2,000 RM
                </div>
                <div className="text-[10px] font-medium text-[#112211]">
                  Medical expenses due to accident
                </div>
              </div>
            </div>
            <div className="w-full flex gap-3">
              <span className="text-primary-700">
                <BusIcon />
              </span>
              <div className="w-full flex flex-col">
                <div className="text-sm font-semibold text-primary-700 mb-3">
                  Up to 2,000 RM
                </div>
                <div className="text-[10px] font-medium text-[#112211]">
                  Medical expenses due to accident
                </div>
              </div>
            </div>
            <div className="w-full flex gap-3">
              <span className="text-primary-700">
                <BusIcon />
              </span>
              <div className="w-full flex flex-col">
                <div className="text-sm font-semibold text-primary-700 mb-3">
                  Up to 2,000 RM
                </div>
                <div className="text-[10px] font-medium text-[#112211]">
                  Medical expenses due to accident
                </div>
              </div>
            </div>
          </div>
          <div className="w-full h-[0.5px] bg-[#C4C4C480] my-6" />
          <label className="w-full flex items-center gap-4">
            <Checkbox
              label=""
              checked={booking.travel_protection_price}
              changeChecked={() => {
                if (booking.travel_protection_price) {
                  dispatch(
                    setBooking({
                      ...booking,
                      travel_protection_price: "",
                    })
                  );
                } else {
                  dispatch(
                    setBooking({
                      ...booking,
                      travel_protection_price: travelProtectionPrice,
                    })
                  );
                }
              }}
            />
            <div className="text-black text-[12px] sm:text-sm font-medium">
              I would like to secure my trips with the travel insurance. (Per
              passenger for just {travelProtectionPrice} RM)
            </div>
          </label>
        </div>
      </div>
      <div className="w-full bg-white shadow-cityCard px-5 md:px-8 py-6 md:py-8">
        <button
          onClick={handleProceed}
          className="w-full h-[48px] px-4 py-3 bg-primary-700 flex items-center justify-center rounded-[4px] text-sm font-semibold text-white"
        >
          Proceed
        </button>
      </div>
    </div>
  );
}

export default Step2;
